import { XMarkIcon } from '@heroicons/react/16/solid';
import { useTranslation } from 'react-i18next';
import { ChatEnum } from '../../../../Chat.enum.ts';
import { useMessageBarContext } from '../../MessageBar.hook.ts';

export default function WapiScheduleSelector() {
  const { t } = useTranslation('chat/chat');
  const { setSelectedAction, passDataToLegacyInput, setIsSchedulePickerMode } = useMessageBarContext();

  function handleSelectMessage() {
    passDataToLegacyInput(ChatEnum.PROGRAMMED_MESSAGES);
  }

  function handleSelectTemplate() {
    setIsSchedulePickerMode(true);
    setSelectedAction(ChatEnum.WABTEMPLATES);
  }

  function handleClose() {
    setIsSchedulePickerMode(false);
    setSelectedAction(ChatEnum.CHAT);
  }

  return (
    <div className="flex items-center gap-3 px-4 py-2 bg-success/10 border border-success/30">
      <strong className="text-sm text-primary whitespace-nowrap">
        {t('wapiScheduleSelector.title')}
      </strong>
      <div className="flex">
        <button
          onClick={handleSelectMessage}
          className="border border-primary text-primary rounded-l-md px-3 py-1 text-sm hover:bg-primary/10"
        >
          {t('wapiScheduleSelector.message')}
        </button>
        <button
          onClick={handleSelectTemplate}
          className="border border-primary text-primary rounded-r-md px-3 py-1 text-sm hover:bg-primary/10"
        >
          {t('wapiScheduleSelector.template')}
        </button>
      </div>
      <XMarkIcon
        onClick={handleClose}
        className="w-5 h-5 text-base-content/50 cursor-pointer hover:text-base-content ml-auto"
      />
    </div>
  );
}
